<template>
  <div class="cart">
    <div v-if="review === 0" class="container">
      <div class="row">
        <div class="col-4"><button class="cart-buttons">Cart</button></div>
        <div class="col-4">
          <button
            class="cart-buttons"
            style="  background: linear-gradient(to left, #05cefc, #5659ce); color: #fff"
          >
            Billing
          </button>
        </div>
        <div class="col-4"><button class="cart-buttons">Review</button></div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-7 col-lg-7">
          <div class="title mt-5">
            <h4>Billing Adress</h4>
          </div>
          <div class="mt-5 ml-4">
            <h3 style="margin-bottom:0" class="my-address">MY ADDRESS:</h3>
            <h3 style="margin-bottom:0" class="my-address">{{ user.name }}</h3>
            <p style="margin-bottom:0" class="mt-3">{{ user.email }}</p>
            <div class="form-group my-3">
              <label for="exampleFormControlTextarea1">Your Adress</label>
              <textarea
                v-model="address"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
            <div class="form-group my-3">
              <label for="exampleFormControlTextarea1">Your Province</label>
              <select
                v-model="provinceId"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <option
                  v-for="province in provinces"
                  :value="province._id"
                  v-bind:key="province._id"
                  >{{ province.title }}</option
                >
              </select>
            </div>
            <div v-if="provinceId != ''" class="form-group my-3">
              <label for="exampleFormControlTextarea1">Your City</label>
              <select
                v-model="cityId"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <option
                  v-for="city in cites"
                  :value="city._id"
                  v-bind:key="city._id"
                  >{{ city.title }}</option
                >
              </select>
            </div>
            <p>Iraq</p>
            <div style="display: flex;align-items: center;">
              <h3 style="margin-bottom:0; display: inline" class="my-address">
                Phone
              </h3>
              <p style="margin-bottom:0; padding-left: 8px">{{ user.phone }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5">
          <div class="title mt-5">
            <h4>Chose your payment method</h4>
          </div>
          <div class="payment-card mt-5">
            <div
              style="width: 150px; height: 80px"
              class="image-container-card py-2 pl-2"
            >
              <img
                width="100%"
                height="100%"
                src="http://footki.com/wp-content/uploads/2018/02/Cash-on-delivery.png"
              />
            </div>
            <div style="font-weight: bolder" class="card-price mr-4">
              {{ delivary_price | toCurrency }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <button class="contnue-button" @click="review = 1">
          Conform your billing information
        </button>
      </div>
    </div>
    <div v-if="review === 1" class="container">
      <div class="row">
        <div class="col-4"><button class="cart-buttons">Cart</button></div>
        <div class="col-4"><button class="cart-buttons">Billing</button></div>
        <div class="col-4">
          <button
            class="cart-buttons"
            style="  background: linear-gradient(to left, #05cefc, #5659ce); color: #fff"
          >
            Review
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-7 col-lg-7">
          <div class="title mt-5">
            <h4>Billing Adress</h4>
          </div>
          <div class="mt-5 ml-4">
            <h3 style="margin-bottom:0" class="my-address">MY ADDRESS:</h3>
            <h3 style="margin-bottom:0" class="my-address">{{ user.name }}</h3>
            <p style="margin-bottom:0" class="mt-3">{{ user.email }}</p>
            <div class="form-group my-3">
              <label style="font-weight: bold" for="exampleFormControlTextarea1"
                >Your Adress:
              </label>
            </div>
            <div class="form-group my-3">
              Iraq
            </div>
            <div class="form-group my-3">
              {{ province }}
            </div>
            <div v-if="provinceId != ''" class="form-group my-3">
              {{ city }}
            </div>
            <div v-if="address" class="form-group my-3">
              {{ address }}
            </div>
            <div style="display: flex;align-items: center;">
              <p style="margin-bottom:0; display: inline" class="my-address">
                Phone {{ user.phone }}
              </p>
            </div>
            <div class="form-group my-3">
              <label style="font-weight: bold" for="exampleFormControlTextarea1"
                >If you have any notes , leave them here:
              </label>
              <textarea
                v-model="orderNotes"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5">
          <div class="title mt-5">
            <h4>Your Items</h4>
          </div>
          <div
            v-for="item in cart"
            v-bind:key="item._id"
            class="payment-card-second mt-5"
          >
            <div
              style="width: 80px; height: 80px"
              class="image-container-card py-2 pl-2"
            >
              <img
                width="100%"
                height="100%"
                v-bind:src="
                  'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                    item.product.images[0]
                "
              />
            </div>
            <div
              style="font-weight: bolder"
              class="card-price-second ml-2 mr-4"
            >
              {{ item.product.title }}
            </div>
            <div style="font-weight: bolder" class="card-price-second mr-4">
              {{ item.totalQuantities }} x
              {{ (item.totalPrice / item.totalQuantities) | toCurrency }}
            </div>
          </div>

          <h4 class="mt-2">
            Total items Price: {{ total_price | toCurrency }} IQD
          </h4>
          <h4 class="mt-2">
            Delivary price: {{ delivary_price | toCurrency }} IQD
          </h4>
          <h4 style="border-top: 2px solid #c1c2c5" class="mt-4 pt-2">
            Total: {{ (total_price + delivary_price) | toCurrency }} IQD
          </h4>
        </div>
      </div>
      <div class="row mt-3">
        <button class="contnue-button" @click="checkout">
          Checkout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import Swal from "sweetalert2";

import axios from "axios";
export default {
  data: () => {
    return {
      delivary_price: "",
      cart: [],
      total_price: 0,
      user: [],
      review: 0,
      orderNotes: "",
      provinceId: "",
      cityId: "",
      address: "",
      province: "",
      city: "",
      // cart: [],
      // total_price: 0
      provinces: [],
      cites: [],
    };
  },
  watch: {
    provinceId: function(val) {
      this.getCites(val);
      this.setDelivaryPrice(val);
      this.setProvince(val);
    },
    cityId: function(val) {
      this.setCity(val);
    },
  },
  created() {
    this.getProvinces();
    this.getUserProfile();
    this.getCart();
  },
  methods: {
    getProvinces() {
      axios
        .get("https://api.ardunic.com/v1/provinces")
        .then((res) => (this.provinces = res.data.data));
    },
    getCites(id) {
      axios
        .get(`https://api.ardunic.com/v1/cities/${id}`)
        .then((res) => (this.cites = res.data.data));
    },
    getUserProfile() {
      axios
        .get("https://api.ardunic.com/v1/user", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => (this.user = res.data.data));
    },
    getCart() {
      axios
        .get("https://api.ardunic.com/v1/cart", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.cart = res.data.data;
          res.data.data.forEach((item) => {
            this.total_price += item.totalPrice;
          });
        });
    },
    setDelivaryPrice(id) {
      this.provinces.filter((prov) => {
        if (prov._id == id) return (this.delivary_price = prov.price);
      });
    },
    setProvince(id) {
      this.provinces.filter((prov) => {
        if (prov._id == id) return (this.province = prov.title);
      });
    },
    setCity(id) {
      this.cites.filter((city) => {
        if (city._id == id) return (this.city = city.title);
      });
    },
    async checkout() {
      let data = {
        orderNotes: this.orderNotes,
        location: {
          provinceId: this.provinceId,
          cityId: this.cityId,
          address: this.address,
        },
      };
      axios
        .post("https://api.ardunic.com/v1/order", data, {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            width: "20rem",
            title: "Your order has been created",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            router.push("/");
          }, 2000);
        });
    },
  },
};
</script>

<style scoped>
.cart {
  margin-top: 120px;
}

.title h4 {
  font-weight: bolder;
}

#chipss {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

#chipss2 {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

.items-card {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #c1c2c5;
}

.left-wing {
  display: flex;
  align-items: center;
}

.right-wing {
  margin-right: 15px;
}

.price h5 {
  color: rgb(26, 91, 211);
  text-align: right;
  font-size: 20px;
  font-weight: bolder;
}

.item-title h5 {
  font-weight: bold;
  margin-bottom: 15px;
}

.item-stock {
  font-size: 18px;
  letter-spacing: 1.6;
}
.info {
  margin-left: 10px;
}

.cart-buttons {
  width: 100%;
  padding: 20px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
}

.contnue-button {
  width: 100%;
  text-align: center;
  padding: 20px 50px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to right, #09f7ff, #05f040);
  color: #fff;
}

.total-card {
  width: 50%;
  text-align: center;
  padding: 10px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to left, #05cefc, #5659ce);
  color: #fff;
}

.options-btn {
  width: 100px;
  border-radius: 30px;
  border: none;
  margin-left: 5px;
  background: #fff;
  border: 1px solid #c1c2c5;
}

.options {
  display: flex;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px 20px 10px;
}

.cart-item:not(:last-child) {
  border-bottom: 1px solid #c1c2c5;
}

.img-container {
  width: 250px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-container img {
  padding: 15px;
}

.my-address {
  font-weight: bolder;
}

.payment-card {
  width: 100%;
  height: 100px;
  background: linear-gradient(to left, #ff4254, #f177fd);
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-price-second {
  color: black;
}

.payment-card-second {
  width: 100%;
  height: 100px;
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}
</style>
